"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'config.tooltips.chat.pick.kdb': 'Wybierz bazę danych wiedzy dla ulepszonych odpowiedzi',
    'config.tooltips.chat.settings': 'Otwórz ustawienia czatu, aby skonfigurować opcje',
    'config.tooltips.send.prompt': 'Wyślij wiadomość',
    'config.tooltips.prompt.with.microphone': 'Wiadomość z mikrofonem',
    'config.tooltips.attach.file.to.prompt': 'Dołącz plik do wiadomości',
    'config.tooltips.cancel.request': 'Anuluj żądanie',
};
